<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M10.7 13.3502V16.0752C10.7 16.4419 10.8291 16.7544 11.0875 17.0127C11.3458 17.271 11.6583 17.4002 12.025 17.4002C12.3916 17.4002 12.7041 17.271 12.9625 17.0127C13.2208 16.7544 13.35 16.4419 13.35 16.0752V13.3502H16.075C16.4416 13.3502 16.7541 13.221 17.0125 12.9627C17.2708 12.7044 17.4 12.3919 17.4 12.0252C17.4 11.6585 17.2708 11.346 17.0125 11.0877C16.7541 10.8294 16.4416 10.7002 16.075 10.7002H13.35V7.9252C13.35 7.55853 13.2208 7.24603 12.9625 6.9877C12.7041 6.72936 12.3916 6.6002 12.025 6.6002C11.6583 6.6002 11.3458 6.72936 11.0875 6.9877C10.8291 7.24603 10.7 7.55853 10.7 7.9252V10.7002H7.92495C7.55828 10.7002 7.24578 10.8294 6.98745 11.0877C6.72912 11.346 6.59995 11.6585 6.59995 12.0252C6.59995 12.3919 6.72912 12.7044 6.98745 12.9627C7.24578 13.221 7.55828 13.3502 7.92495 13.3502H10.7ZM12 22.8002C10.506 22.8002 9.10195 22.5167 7.78795 21.9497C6.47395 21.3827 5.33095 20.6132 4.35895 19.6412C3.38695 18.6692 2.61745 17.5262 2.05045 16.2122C1.48345 14.8982 1.19995 13.4942 1.19995 12.0002C1.19995 10.5019 1.48394 9.09392 2.05193 7.77617C2.61991 6.4584 3.39074 5.31214 4.36443 4.33737C5.33811 3.36259 6.4811 2.59603 7.7934 2.0377C9.1057 1.47936 10.5079 1.2002 12 1.2002C13.4981 1.2002 14.9059 1.47936 16.2235 2.0377C17.5411 2.59603 18.6875 3.3627 19.6625 4.3377C20.6375 5.3127 21.4041 6.45922 21.9625 7.77727C22.5208 9.09534 22.8 10.5037 22.8 12.0023C22.8 13.5009 22.5208 14.9044 21.9625 16.2127C21.4041 17.521 20.6376 18.662 19.6628 19.6357C18.688 20.6094 17.5417 21.3802 16.224 21.9482C14.9062 22.5162 13.4982 22.8002 12 22.8002Z"
        :fill="color"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "st-icon",
  props: {
    color: {
      type: String,
      default: "#6D202B",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
